import moment from 'moment';

import { stockConstants } from '../../constants';
import { Category } from '../../py-generated/datalouder/stock/types';
import { ccassService, dailypriceService, stockService } from '../../services';
import { FetchAllStocksResponseBody } from '../../shared/types';
import { alertActions } from '..';
import { generalErrorHandler, resetAbortController } from '../utils';

export default function fetchLookupRelated(
  language: string,
  category: Category,
  industryId: string,
  subIndustryId: string
) {
  return dispatch => {
    const ac = resetAbortController(stockConstants.LOOKUP_CATE_REQUEST);
    dispatch(request());
    dispatch(alertActions.clear());

    const dateStr = moment.utc().format('YYYYMMDD');

    return Promise.all([
      stockService.listStocksByIndustries(category, industryId, subIndustryId),
      ccassService.latestStockNews(ac.signal, language),
      dailypriceService.statisticsv2(ac.signal, category, dateStr),
      stockService.fetchAllStocks(category),
    ]).then(
      ([data, latestNews, statisticsv2, stocksByTicker]) => {
        dispatch(
          success(
            new Set(data[0].map(stockId => stockId.split('#')[0])),
            new Set(data[1].map(stockId => stockId.split('#')[0])),
            stocksByTicker,
            statisticsv2,
            latestNews
          )
        );
      },
      generalErrorHandler(dispatch, error =>
        dispatch(failure(error.toString()))
      )
    );
  };

  function request() {
    return { type: stockConstants.LOOKUP_CATE_REQUEST };
  }
  function success(
    categoryStockTickers: Set<string>,
    subCategoryStockTickers: Set<string>,
    stocksByTicker: FetchAllStocksResponseBody,
    statisticsv2,
    latestNews
  ) {
    const latestNewsByStockCode = {};
    for (const item of latestNews) {
      // latestNews' stock code is normalized stock code in the form of "hk.700"
      const stockCode = item.StockCode.split('.')[1].padStart(5, '0');
      latestNewsByStockCode[stockCode] = item;
    }

    const categoryStats = [];
    const subCategoryStats = [];

    for (const stockId in statisticsv2.data) {
      const stat = statisticsv2.data[stockId];
      const ticker = stockId.split('#')[0];
      stat.stockCode = ticker;

      // add news
      stat.news = latestNewsByStockCode[ticker];
      if (stat.news) {
        stat.newsTime = stat.news.ReleaseTime;
      }

      // add other metadata
      if (stocksByTicker[ticker]) {
        const stockInfo = stocksByTicker[ticker];
        [stat.name_en, stat.name_zh] = [stockInfo.name.en, stockInfo.name.zh];
      }

      if (categoryStockTickers.has(ticker)) categoryStats.push(stat);
      if (subCategoryStockTickers.has(ticker)) subCategoryStats.push(stat);
    }
    return {
      type: stockConstants.LOOKUP_CATE_SUCCESS,
      categoryStats,
      subCategoryStats,
      realtime: statisticsv2.realtime,
    };
  }
  function failure(error) {
    return { type: stockConstants.LOOKUP_CATE_FAILURE, error };
  }
}
